<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container">
        <a class="navbar-brand" href="#">Wrona School</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav me-auto">
            <li class="nav-item"><router-link class="nav-link" to="/courses">Courses</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/pricing">Pricing</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/about">About Us</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/portfolio">Portfolio</router-link></li>
            <li class="nav-item"><router-link class="nav-link" to="/contact">Contact Us</router-link></li>
          </ul>
          <ul class="navbar-nav">
            <li class="nav-item"><router-link class="btn btn-outline-light me-2" to="/login">Log In</router-link></li>
            <li class="nav-item"><router-link class="btn btn-outline-light" to="/register">Sign Up</router-link></li>
          </ul>
        </div>
      </div>
    </nav>

    <section class="main-section">
      <h2 class="text-white text-center">Welcome to Wrona School - Article 1</h2>
      <button class="nav-arrow prev-arrow position-absolute top-50 start-0 translate-middle-y">&lt;</button>
      <button class="nav-arrow next-arrow position-absolute top-50 end-0 translate-middle-y">&gt;</button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
};
</script>
